export default __webpack_public_path__ + "static/media/cross_icon_white.6b4fb6ea.svg";